import * as Models from "../ts/rlAdmin.models";
import * as Utils from "../ts/rlAdmin.utils";
import * as Consts from "../ts/rlAdmin.consts";
import * as angular from "angular";
import { EntityService } from "../services/entity-service";
import { NotifyService } from "../services/notify-service";

RLTemplateHierarchyCountItem.$inject = ["$compile"];
export function RLTemplateHierarchyCountItem($compile: ng.ICompileService) {
    var directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/template-hierarchy-count-item.html"),
        require: ["rlTemplateHierarchyCountItem"],
        controllerAs: "thciVM",
        controller: RLTemplateHierarchyCountItemController,
        bindToController: true,
        scope: {
            template: "=template",
            charTypeID: "=charTypeId"
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controllers: [RLTemplateHierarchyCountItemController]) => {
            controllers[0].Init().then(() => {
                if (controllers[0].template.childTemplates.length > 0) {
                    var templateElement = angular.element("<div class='child'><rl-template-hierarchy-count-recursive ng-show='thciVM.template.numberOfRecords > 0' child-templates='thciVM.template.childTemplates' char-type-id='thciVM.charTypeID' /></div>");
                    var compiled = $compile(templateElement);
                    element.append(templateElement);
                    compiled(scope);
                }
            });
        }
    };
    return directive;
}

export class RLTemplateHierarchyCountItemController {
    static $inject = ["$element", "$scope", "$window", "$filter", "$q", "notifyService", "entityService"];


    charTypeID: number;

    template: Models.ITemplateHierarchy;
    // childTemplates: Models.ITemplateHierarchy[];
    showTemplateHierarchy: boolean;

    constructor(
        private $element: ng.IAugmentedJQuery, private $scope: ng.IScope, private $window: ng.IWindowService, private $filter: ng.IFilterService, private $q: ng.IQService, private notifyService: NotifyService,
        private entityService: EntityService) {


    }

    Init() {
        this.notifyService.startProgress();

        return this.entityService.getAssociatedTemplatesForTemplate(this.charTypeID, this.template.templateID, this.charTypeID).
            then((result) => {
                this.template.childTemplates = [];
                result.forEach(t => {
                    var parentTemplates = angular.copy(this.template.directParentTemplates);
                    parentTemplates.push(this.template.templateID);
                    var newTemp: Models.ITemplateHierarchy = { directParentTemplates: parentTemplates, templateID: t.templateID, templateLabel: t.templateName, childTemplates: null, level: this.template.level + 1, numberOfRecords: 0 };
                    //check that this template doesn't exist in the recursive line of direct parent templates
                    if (parentTemplates.indexOf(newTemp.templateID) == -1) {
                        this.template.childTemplates.push(newTemp);
                    }
                });
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

}
